import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/utils/styles';
import type { Section } from '@viome/viome-base/src/api/Strapi/StrapiTypes';

type AddonFAQProps = {
  section: Section;
  className?: string;
};

export const AddonFAQ = ({ section, className }: AddonFAQProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className={className}>
      <h2 className="font-sans text-xl font-medium text-[#111] tracking-tight mb-5">
        {section.title}
      </h2>
      <div className="divide-y divide-gray-200">
        {section.faqs?.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div key={idx} className="py-1">
              <button
                className="flex items-center justify-between w-full py-3 text-left"
                onClick={() => setOpenIndex(isOpen ? null : idx)}
              >
                <span className="font-sans text-sm font-medium text-[#111] tracking-tight pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={cn(
                    'h-[18px] w-[18px] text-gray-500 shrink-0 transition-transform duration-200',
                    isOpen && 'rotate-180',
                  )}
                />
              </button>
              {isOpen && (
                <p className="font-sans font-light text-sm leading-[130%] text-tertiary pb-3">
                  {faq.answer}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
